const backendURL = process.env.VUE_APP_BACKEND_URL
// Vue CLI only exposes env vars prefixed with VUE_APP_
const subdomain = process.env.VUE_APP_SUBDOMAIN || process.env.SUBDOMAIN || ''
const ALLOWED_SUBDOMAINS = ['aero-invoice', 'search-demo', 'retail', 'greenwood']

function getCookie(token) {
    const cookies = document.cookie.split('; ')

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=')
        if (cookie[0] === token) {
            return cookie[1]
        }
    }

    return null
}

function resolveHostSubdomain() {
    if (typeof window === 'undefined' || !window.location) {
        return 'greenwood'
    }

    const hostParts = (window.location.hostname || '').split('.').filter(Boolean)
    const candidate = hostParts.find(part => ALLOWED_SUBDOMAINS.includes(part.toLowerCase()))
    if (!hostParts.length) return 'greenwood'
    
    return candidate ? candidate.toLowerCase() : 'greenwood'
}

function getSubdomain() {
    if (subdomain) {
        return String(subdomain).toLowerCase()
    }

    return resolveHostSubdomain()
}

function getSubdomainHeader() {
    const resolved = getSubdomain()
    return resolved ? { 'X-Subdomain': resolved } : {}
}

function isRetail() {
    return getSubdomain() === 'retail'
}

function isSearchDemo() {
    return getSubdomain() === 'search-demo'
}

function isInvoiceDashboard() {
    return getSubdomain() === 'aero-invoice'
}

export default {
    get sessionToken() {
        return getCookie('token')
    },
    getCookie,
    backendURL,
    subdomain,
    getSubdomain,
    getSubdomainHeader,
    isRetail,
    isSearchDemo,
    isInvoiceDashboard,
}
